/*eslint-disable */
<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card>
          <template v-slot:headerTitle v-if="!propOpenedInModal">
            <h4 class="card-title">{{ cvCardTitle }}</h4>
          </template>
          <template v-slot:body>
            <p v-if="!propOpenedInModal">{{ cvCardSubHeader }}</p>
            <form action="#">
              <div class="form-row">
                <div class="col-md-12 mb-3">
                  <label for="validationskill_name">
                    {{cvSkillNameLabel}}</label
                  >
                  <input
                    v-model="vmGpath_skill_recoFormData.skill_name"
                    type="text"
                    class="form-control"
                    required
                  />
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationskill_desc">
                    {{cvSkillDescLabel}}</label
                  >
                  <textarea
                  v-model="vmGpath_skill_recoFormData.skill_desc"
                    type="text"
                    class="form-control textarea"
                    required>
                  </textarea>
                </div>
              </div>
              <div class="form-group">
                <button v-if="cvLoadingStatus" type="button" class="btn btn-primary" :disabled="cvLoadingStatus">
                   <b-spinner label="Spinning"></b-spinner>
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="gpath_skill_recoAdd()"
                >
                  {{ cvSubmitBtn }}
                </button>
              </div>
            </form>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-toast
      v-model="showToast"
      name="Toast"
      :auto-hide-delay="toastVariant === 'danger' ? 10000 : 1000"
      :variant="toastVariant"
      :title="toastTitle"
    >
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>

<script>
import { gpathSkillRecos } from "../../../FackApi/api/GpathSkillReco.js"
import ApiResponse from "../../../Utils/apiResponse"
import { socialvue } from "../../../config/pluginInit"

export default {
  name: "gpathSkillRecoAdd",
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      cvCardTitle: "Add GPath Skill Reco",
      cvCardSubHeader: "Add GPath Skill Reco",
      cvSubmitBtn: "Add",
      cvSkillNameLabel: "skill name",
      cvSkillDescLabel: "skill desc",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      cvLoadingStatus: false,
      toastTitle: "GPath Skill Reco Added",
      vmGpath_skill_recoFormData: Object.assign({}, this.initFormData()),
      vmGpath_skill_recoDesc: null,
      vmGpath_skill_recoType: null
    }
  },
  mounted () {
    socialvue.index()
  },
  methods: {
    /**
     * initFormData
     */
    initFormData () {
      return {
        "skill_name": "",
        "skill_desc": ""
      }
    },
    /**
     * validate
     */
    validate () {
      try {
        for (let index in this.vmGpath_skill_recoFormData) {
          if (!this.vmGpath_skill_recoFormData[index]) {
            this.toastMsg = "Missing " + index.split("_").join(" ")
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }
        return true
      }
      catch (err) {
        console.error("Exception occurred at validate() and Exception:", err.message)
      }
    },
    /**
     * gpath_skill_recoAdd
     */
    async gpath_skill_recoAdd () {
      // if (!this.validate()) {
      //   return false
      // }
      try {
        this.cvLoadingStatus = true
        let gpathSkillRecoAddResp = await gpathSkillRecos.gpath_skill_recoAdd(this, this.vmGpath_skill_recoFormData)
        await ApiResponse.responseMessageDisplay(this, gpathSkillRecoAddResp)
        if (gpathSkillRecoAddResp && !gpathSkillRecoAddResp.resp_status) {
          return false
        }
        //  Emit if opened in Modal
        if (this.propOpenedInModal) {
          this.$emit("emitCloseGpath_skill_recoAddModal", gpathSkillRecoAddResp.resp_data)
        }
        this.vmGpath_skill_recoFormData = Object.assign({}, this.initFormData())
      }
      catch (err) {
        console.error("Exception occurred at gpath_skill_recoAdd() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    }
  }
}
</script>
<style scoped>
 textarea{
    height: 195px !important;
    overflow-y: scroll;
    line-height: 18px !important;
  }
</style>
